import {
  FacebookLandingPage,
  HomePage,
  //Avista Flow
  AvistaHomePage,
  //CreditPage
  CreditPage,
  AcuotasPage,
  NosotrosPage,
  NotFoundPage,
  FaqsPage,
  ContactPage,
  RatesPage,
  TermsPage,
  DataPage,
  FisicoPage,
  RequisitosPage,
  ComoFuncionaPage,
  SignupPage,
  SigninPage,
  VerificationEmailPage,
  VerificationPage,
  FormulariounoPage,
  FormulariodosPage,
  PreaprobadoPage,
  OfertaPage,
  CrezuPage,
  ErrorPage,
  ContratoPage,
  PagarePage,
  FirmaPage,
  ConfirmadoPage,
  ProfilePage,
  UpdateDataPage,
  MyCreditPage,
  PayLoginPage,
  MethodsPage,
  CashOptionsPage,
  CashPayPage,
  CashPayEfectyPage,
  CashPayWUPage,
  PayHome,
  ExtendPage,
  CreditDetailPage,
  BancoPage,
  RenovarPage,
  ConfirmarPage,
  IndexBlogPage,
  AumentarCupoPage,
  MejorarPuntajePage,
  PorQueNegaronPage,
  ComoConstruirPage,
  NConsejosParaPage,
  AppsPage,
} from "./pages";
import { ImportQuotas } from "../src/pages/backoffice/imports/importQuotas";

import { Routes, Route } from "react-router-dom";
// Navbars
import { NavbarHome } from "./components/navigation/NavbarHome";
import { NavbarIndex } from "./components/navigation/NavbarIndex";
import { NavbarLogin } from "./components/navigation/NavbarLogin";
import { SimpleNavbar } from "./components/navigation/SimpleNavbar";
// Footers
import { Footer } from "./components/navigation/Footer";

import { CreditProvider } from "./context/creditContext";
import { useNavigate } from "react-router-dom";
//CONTEXT
import { TokenState } from "./context/Auth/AuthState";
import { CreditUserState } from "./context/CreditUser/CreditUserState";
import { FormOneState } from "./context/FormOne/FormOneState";
import { FormTwoState } from "./context/FormTwo/FormTwoState";
import { OfertaViewState } from "./context/OfertaContext/OfertaViewState";
import { ImportPaymentsEfecty } from "./pages/backoffice/imports/importPaymentsEfecty";
import { ImportIncrementQuota } from "./pages/backoffice/imports/importIncrementQuota";
import { ImportApproved } from "./pages/backoffice/imports/importApprovedListupdate";
import { ImportPaymentsEfectyExtendCredit } from "./pages/backoffice/imports/importPaymentEfectyExtendCredit";
import "./index.css";
import { CashPayPageExtend } from "./pages/dashboard/pagos/CashPayPageExtend";
import { DashboardsBackOffice } from "./components/backgrounds/DashboardsBackoffice";
import CardSlider from "./components/slider/slidertest";
import { TMLVform } from "./pages/backoffice/tmlv/tmlvForm";
import { FESiigo } from "./pages/backoffice/siigo/fe";
import { ReportesAcierta } from "./pages/backoffice/datacredito/reportesAcierta";
import { ReportesReconocer } from "./pages/backoffice/datacredito/reportesReconocer";
import { ReportePoliticasMotor } from "./pages/backoffice/datacredito/reportePoliticasMotor";
import { GenerarContrato } from "./pages/backoffice/configuraciones/generarContratoPdf";
import { VerificationPhonePage } from "./pages/autentication/VerificationPhonePage";
import { ImportRestrictListGalilea } from "./pages/backoffice/imports/importRestrictGalileaList";
import { OperationFunnelDetail } from "./pages/backoffice/apileads/FunnelDetail";
import { validateSessionAndJwtToken } from "./utils/validateTokenSession";
import { InactivityProvider } from "./providers/session/inactivityProvider";
import { returnToSignin } from "./utils/returnToSign";
import { GenerateCobreLinkPayment } from "./pages/backoffice/pagos/generarLinkCobre";
import { InteresCorrienteConfig } from "./pages/backoffice/configuraciones/interesCorriente";
import { InteresMoratorioConfig } from "./pages/backoffice/configuraciones/interesMoratorio";
import { CreateVerifyAccount } from "./pages/backoffice/cuentasBancarias/createVerifyAccount";
import { FriendsViewState } from "./context/Disclosures/friends/friendsState";
import { NotificationsState } from "./context/Disclosures/notifications/notificationsState";
import { RewardsViewState } from "./context/Disclosures/rewards/rewardsState";
import { ImportDisbursements } from "./pages/backoffice/imports/importDisbursements";
import { ReporteUtmLeads } from "./pages/backoffice/reports/reporteUtmLeads";
import { GenerarPagare } from "./pages/backoffice/configuraciones/generarPagare";
import { LevelCustomerPage } from "./pages/dashboard/profile/LevelCustomerPage";
import { ChatBot } from "./components/chatia/ChatBot";
import { ChatProvider } from "./context/ChatIaContext/ChatIaContext";

function App() {
  let navigate = useNavigate();

  const validaToken = async () => {
    setInterval(async () => {
      const isSignin = localStorage.getItem("is_signin");
      if (isSignin === true || isSignin === "true") {
        let isValidToken = await validateSessionAndJwtToken();
        if (isValidToken) {
          console.log("Token Valido.");
        } else {
          returnToSignin(navigate);
        }
      } else {
        console.log("Not logged...");
      }
    }, 1200000);
  };

  validaToken();

  return (
    <div className="font-walsheim text-tdark tracking-tight">
      <div className="">
        <TokenState>
          <FormOneState>
            <FormTwoState>
              <CreditUserState>
                <OfertaViewState>

                  {/* Start Avista flow area*/}

                  <FriendsViewState>
                    <NotificationsState>
                      <RewardsViewState>
                      {/*   <ChatProvider> */}
                   {/*        <ChatBot /> */}
                          <Routes>
                            <Route
                              exact
                              path="/credito-pensionados"
                              element={
                                <div>
                                  <SimpleNavbar />
                                  <AvistaHomePage />
                                </div>
                              }
                            />

                            {/* Start Facebook Landing area*/}
                            <Route
                              exact
                              path="/facebook-ads"
                              element={
                                <div>
                                  <NavbarHome />
                                  <FacebookLandingPage />
                                  <Footer />
                                </div>
                              }
                            />

                            {/* Start Home area*/}
                            <Route
                              exact
                              path="/"
                              element={
                                <div>
                                  <NavbarIndex current1={true} />
                                  <HomePage />
                                  <Footer />
                                </div>
                              }
                            />
                            <Route
                              exact
                              path="/creditos"
                              element={
                                <div>
                                  <NavbarHome current1={true} />
                                  <CreditPage />
                                  <Footer />
                                </div>
                              }
                            />
                            <Route
                              exact
                              path="/a-cuotas"
                              element={
                                <div>
                                  <NavbarHome current1={true} />
                                  <AcuotasPage />
                                  <Footer />
                                </div>
                              }
                            />

                            <Route
                              path="/nosotros"
                              element={
                                <div>
                                  <NavbarHome current2={true} />
                                  <NosotrosPage />
                                  <Footer />
                                </div>
                              }
                            />
                            <Route
                              path="/tarifas"
                              element={
                                <div>
                                  <NavbarHome current3={true} />
                                  <RatesPage />
                                  <Footer />
                                </div>
                              }
                            />
                            <Route
                              path="/faqs"
                              element={
                                <div>
                                  <NavbarHome current5={true} />
                                  <FaqsPage />
                                  <Footer />
                                </div>
                              }
                            />
                            <Route
                              path="/contactanos"
                              element={
                                <div>
                                  <NavbarHome />
                                  <ContactPage />
                                  <Footer />
                                </div>
                              }
                            />
                            <Route
                              path="/terminos"
                              element={
                                <div>
                                  <NavbarHome />
                                  <TermsPage />
                                  <Footer />
                                </div>
                              }
                            />
                            <Route
                              path="/datos"
                              element={
                                <div>
                                  <NavbarHome />
                                  <DataPage />
                                  <Footer />
                                </div>
                              }
                            />
                            <Route
                              path="/fisico"
                              element={
                                <div>
                                  <NavbarHome />
                                  <FisicoPage />
                                  <Footer />
                                </div>
                              }
                            />
                            <Route
                              path="/requisitos"
                              element={
                                <div>
                                  <NavbarHome current6={true} />
                                  <RequisitosPage />
                                  <Footer />
                                </div>
                              }
                            />
                            <Route
                              path="/como-funciona"
                              element={
                                <div>
                                  <NavbarHome />
                                  <ComoFuncionaPage />
                                  <Footer />
                                </div>
                              }
                            />
                            {/* End Home area*/}

                            {/* Start Blog area */}
                            <Route
                              path="/blog"
                              element={
                                <div>
                                  <NavbarHome />
                                  <IndexBlogPage />
                                  <Footer />
                                </div>
                              }
                            />
                            <Route
                              path="/blog/como-aumentar-mi-cupo-de-credito"
                              element={
                                <div>
                                  <NavbarHome /> <AumentarCupoPage />
                                </div>
                              }
                            />
                            <Route
                              path="/blog/por-que-galilea-nego-mi-solicitud"
                              element={
                                <div>
                                  <NavbarHome /> <PorQueNegaronPage />
                                </div>
                              }
                            />
                            <Route
                              path="/blog/como-mejorar-mi-puntaje-en-datacredito"
                              element={
                                <div>
                                  <NavbarHome /> <MejorarPuntajePage />
                                </div>
                              }
                            />
                            <Route
                              path="/blog/6-consejos-para-manejar-tus-finanzas"
                              element={
                                <div>
                                  <NavbarHome /> <NConsejosParaPage />
                                </div>
                              }
                            />
                            <Route
                              path="/blog/como-construir-historial-crediticio"
                              element={
                                <div>
                                  <NavbarHome /> <ComoConstruirPage />
                                </div>
                              }
                            />
                            <Route
                              path="/blog/4-apps-para-llevar-un-registro-financiero"
                              element={
                                <div>
                                  <NavbarHome /> <AppsPage />
                                </div>
                              }
                            />

                            {/* End Blog area */}

                            {/* Start Not Found area*/}
                            <Route
                              path="*"
                              element={
                                <div>
                                  <NotFoundPage />
                                </div>
                              }
                            />
                            {/* End Not Found area*/}

                            {/* Start login area */}

                            <Route path="/registrarse" element={<SignupPage />} />
                            <Route path="/ingresar" element={<SigninPage />} />
                            <Route
                              path="/autenticarse-email"
                              element={<VerificationEmailPage />}
                            />
                            <Route
                              path="/autenticarse"
                              element={<VerificationPage />}
                            />

                            <Route
                              path="/validate-phone"
                              element={<VerificationPhonePage />}
                            />

                            {/* End login area */}

                            {/* Start Flujo area */}

                            <Route
                              path="/formulariouno"
                              element={
                                <div>
                                  <NavbarLogin /> <FormulariounoPage />
                                </div>
                              }
                            />

                            <Route
                              path="/formulariodos"
                              element={
                                <div>
                                  <NavbarLogin /> <FormulariodosPage />
                                </div>
                              }
                            />

                            <Route
                              path="/preaprobado"
                              element={
                                <div>
                                  <NavbarLogin /> <PreaprobadoPage />
                                </div>
                              }
                            />

                            <Route
                              path="/oferta"
                              element={
                                <div>
                                  <OfertaViewState>
                                    <NavbarLogin /> <OfertaPage />
                                  </OfertaViewState>
                                </div>
                              }
                            />

                            <Route
                              path="/biometria"
                              element={
                                <div>
                                  <CardSlider />
                                </div>
                              }
                            />

                            <Route
                              path="/negado"
                              element={
                                <div>
                                  <NavbarLogin /> <CrezuPage />
                                </div>
                              }
                            />
                            <Route
                              path="/error"
                              element={
                                <div>
                                  <NavbarLogin /> <ErrorPage />
                                </div>
                              }
                            />
                            <Route
                              path="/contrato"
                              element={
                                <div>
                                  <NavbarLogin /> <ContratoPage />
                                </div>
                              }
                            />
                            <Route
                              path="/pagare"
                              element={
                                <div>
                                  <NavbarLogin /> <PagarePage />
                                </div>
                              }
                            />
                            <Route
                              path="/firma"
                              element={
                                <div>
                                  <NavbarLogin /> <FirmaPage />
                                </div>
                              }
                            />
                            <Route
                              path="/confirmado"
                              element={
                                <div>
                                  <NavbarLogin /> <ConfirmadoPage />
                                </div>
                              }
                            />

                            {/* End Flujo area */}

                            {/* Dashboard Usuario */}

                            <Route
                              path="/perfil"
                              element={
                                <InactivityProvider>
                                  {" "}
                                  <CreditProvider>
                                    {" "}
                                    <ProfilePage />{" "}
                                  </CreditProvider>{" "}
                                </InactivityProvider>
                              }
                            />
                            <Route
                              path="/nivel-cliente"
                              element={
                                <InactivityProvider>
                                  {" "}
                                  <CreditProvider>
                                    {" "}
                                    <LevelCustomerPage />{" "}
                                  </CreditProvider>{" "}
                                </InactivityProvider>
                              }
                            />
                            <Route
                              path="/mis-bancos"
                              element={
                                <InactivityProvider>
                                  {" "}
                                  <CreditProvider>
                                    {" "}
                                    <BancoPage />{" "}
                                  </CreditProvider>{" "}
                                </InactivityProvider>
                              }
                            />
                            <Route
                              path="/micredito"
                              element={
                                <InactivityProvider>
                                  {" "}
                                  <CreditProvider>
                                    {" "}
                                    <MyCreditPage />{" "}
                                  </CreditProvider>{" "}
                                </InactivityProvider>
                              }
                            />
                            <Route
                              path="/detalle-credito"
                              element={
                                <InactivityProvider>
                                  {" "}
                                  <CreditProvider>
                                    {" "}
                                    <CreditDetailPage />{" "}
                                  </CreditProvider>{" "}
                                </InactivityProvider>
                              }
                            />
                            <Route
                              path="/pagar"
                              element={
                                <InactivityProvider>
                                  {" "}
                                  <CreditProvider>
                                    {" "}
                                    <PayLoginPage />{" "}
                                  </CreditProvider>{" "}
                                </InactivityProvider>
                              }
                            />
                            <Route
                              path="/extencion"
                              element={
                                <InactivityProvider>
                                  <CreditProvider>
                                    {" "}
                                    <ExtendPage />{" "}
                                  </CreditProvider>{" "}
                                </InactivityProvider>
                              }
                            />
                            <Route
                              path="/medios-de-pago"
                              element={
                                <InactivityProvider>
                                  <CreditProvider>
                                    {" "}
                                    <MethodsPage />{" "}
                                  </CreditProvider>{" "}
                                </InactivityProvider>
                              }
                            />
                            <Route
                              path="/opciones-efectivo"
                              element={
                                <InactivityProvider>
                                  <CreditProvider>
                                    {" "}
                                    <CashOptionsPage />{" "}
                                  </CreditProvider>{" "}
                                </InactivityProvider>
                              }
                            />
                            <Route
                              path="/pago-efectivo"
                              element={
                                <InactivityProvider>
                                  <CreditProvider>
                                    {" "}
                                    <CashPayPage />{" "}
                                  </CreditProvider>{" "}
                                </InactivityProvider>
                              }
                            />
                            <Route
                              path="/pago-efectivo-efecty"
                              element={
                                <InactivityProvider>
                                  <CreditProvider>
                                    {" "}
                                    <CashPayEfectyPage />{" "}
                                  </CreditProvider>{" "}
                                </InactivityProvider>
                              }
                            />
                            <Route
                              path="/pago-efectivo-wu"
                              element={
                                <InactivityProvider>
                                  <CreditProvider>
                                    {" "}
                                    <CashPayWUPage />
                                  </CreditProvider>
                                </InactivityProvider>
                              }
                            />
                            <Route
                              path="/pago-efectivo-extend"
                              element={
                                <InactivityProvider>
                                  <CreditProvider>
                                    {" "}
                                    <CashPayPageExtend />
                                  </CreditProvider>
                                </InactivityProvider>
                              }
                            />
                            <Route
                              path="/pagos"
                              element={
                                <InactivityProvider>
                                  <CreditProvider>
                                    {" "}
                                    <PayHome />
                                  </CreditProvider>
                                </InactivityProvider>
                              }
                            />
                            <Route
                              path="/renovar"
                              element={
                                <InactivityProvider>
                                  <CreditProvider>
                                    {" "}
                                    <RenovarPage />
                                  </CreditProvider>
                                </InactivityProvider>
                              }
                            />
                            <Route
                              path="/renovar/confirmar"
                              element={
                                <InactivityProvider>
                                  <CreditProvider>
                                    {" "}
                                    <ConfirmarPage />
                                  </CreditProvider>
                                </InactivityProvider>
                              }
                            />
                            {/* End Flujo Dashboard Usuario */}

                            {/* BackOffice */}
                            <Route
                              exact
                              path="/backoffice-dashboard"
                              element={<DashboardsBackOffice />}
                            />
                            <Route
                              exact
                              path="/backoffice-import-quotas"
                              element={<ImportQuotas />}
                            />
                            <Route
                              exact
                              path="/backoffice-import-extendsCredit"
                              element={<ImportPaymentsEfectyExtendCredit />}
                            />
                            <Route
                              exact
                              path="/backoffice-import-payments"
                              element={<ImportPaymentsEfecty />}
                            />

                            <Route
                              exact
                              path="/backoffice-import-disbursements"
                              element={<ImportDisbursements />}
                            />

                            <Route
                              exact
                              path="/backoffice-import-incrementquotas"
                              element={<ImportIncrementQuota />}
                            />

                            <Route
                              exact
                              path="/backoffice/import/aprovvedlist"
                              element={<ImportApproved />}
                            />
                            <Route
                              exact
                              path="/backoffice-tmlv"
                              element={<TMLVform />}
                            />

                            <Route
                              exact
                              path="/backoffice-fesiigo"
                              element={<FESiigo />}
                            />

                            <Route
                              exact
                              path="/backoffice-reporteacierta"
                              element={<ReportesAcierta />}
                            />

                            <Route
                              exact
                              path="/backoffice-reportereconocer"
                              element={<ReportesReconocer />}
                            />

                            <Route
                              exact
                              path="/backoffice-politicas-motor"
                              element={<ReportePoliticasMotor />}
                            />

                            <Route
                              exact
                              path="/backoffice-utm-leads"
                              element={<ReporteUtmLeads />}
                            />

                            <Route
                              exact
                              path="/backoffice-generar-contrato"
                              element={<GenerarContrato />}
                            />
                            <Route
                              exact
                              path="/backoffice-generar-pagare"
                              element={<GenerarPagare />}
                            />
                            <Route
                              exact
                              path="/backoffice-generar-lista-restrictiva-galilea"
                              element={<ImportRestrictListGalilea />}
                            />

                            <Route
                              exact
                              path="/backoffice-generate-link-cobre"
                              element={<GenerateCobreLinkPayment />}
                            />

                            <Route
                              exact
                              path="/backoffice-create-verify-account"
                              element={<CreateVerifyAccount />}
                            />

                            <Route
                              exact
                              path="/backoffice-inrteres-corriente"
                              element={<InteresCorrienteConfig />}
                            />

                            <Route
                              exact
                              path="/backoffice-interes-moratorio"
                              element={<InteresMoratorioConfig />}
                            />

                            <Route
                              exact
                              path="/funnel-detail"
                              element={<OperationFunnelDetail />}
                            />
                          </Routes>
                       {/*  </ChatProvider> */}
                      </RewardsViewState>
                    </NotificationsState>
                  </FriendsViewState>
                </OfertaViewState>
              </CreditUserState>
            </FormTwoState>
          </FormOneState>
        </TokenState>
      </div>
    </div >
  );
}

export default App;
